export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			alerts: {
				common: {
					dash: '—',
					na: 'n/a',
					general: 'General',
					unassigned: 'Unassigned graphs',
					refresh: 'Refresh',
					dismiss: 'Dismiss',
				},
				overview: {
					title: 'Alerts Overview',
					subtitle: 'Projects, locations, hubs, and modules with their latest states.',
					refreshError: 'Failed to refresh alert data.',
					loadError: 'Failed to load alert data.',
				},
				graphs: {
					title: 'Graph Alerts',
					subtitle: 'Graphs currently in alert or warning state.',
					table: {
						graph: 'Graph / Equation',
						location: 'Location',
						status: 'Status',
						lastWarn: 'Last Warn',
						lastAlert: 'Last Alert',
						noData: 'No alerts detected across graphs.',
					},
					status: {
						alert: 'alert',
						warning: 'warning',
						ok: 'ok',
					},
				},
				matrixGraphs: {
					title: 'Current Graph States',
					filterLabel: 'Only show alerts & warnings',
					projectLabel: 'Project',
					allProjects: 'All projects',
				},
				widget: {
					title: 'Alarms',
					alert: 'Alert',
					warn: 'Warning',
					ok: 'OK',
					empty: 'No alarms configured',
				},
				matrixUsers: {
					headers: {
						phone: 'Phone',
						role: 'Role',
						email: 'Email',
						sms: 'SMS',
						contact: 'Contact',
						warn: 'Warn',
						alert: 'Alert',
					},
					footerSelectAll: 'Select all',
					empty: 'No custom graphs match the current filter.',
					unknownUser: 'Unknown user',
				},
				matrixGraphTable: {
					headers: {
						graph: 'Graph / Equation',
						state: 'State',
						lastState: 'Last State',
						projectNumber: 'Project #',
						project: 'Project',
						location: 'Location',
						lastCase: 'Last Case',
						sentAt: 'Sent at',
						ok: 'OK',
						preWarn: 'PreWarn',
						warn: 'Warn',
						warnPreAlert: 'WarnPreAlert',
						preAlert: 'PreAlert',
						alert: 'Alert',
					},
					noProject: 'No project',
					noData: 'No graph alert data available.',
				},
				byUser: {
					status: 'Status',
					analyze: 'Analyze Data',
					send: 'Send Messages',
					projectLabel: 'Project',
					allProjects: 'All projects',
					selectProject: 'Select a project',
					onlyAlerts: 'Only graphs with alerts or warnings',
					usersEquations: '{users} users • {equations} equations',
					unsaved: 'Unsaved changes',
					save: 'Save',
					modalTitle: 'Alert Status Overview',
					modalAlt: 'Status analysis',
					confirmSend: 'Send warning emails to recipients?',
					toastAnalyzeSuccess: 'Alert data recalculated successfully.',
					toastAnalyzeError: 'Failed to analyze alert data.',
					toastSendSuccess: 'Messages queued successfully.',
					toastSendError: 'Failed to send messages.',
					toastSaveSuccess: 'Alert settings saved.',
					toastSaveError: 'Failed to save alert settings.',
				},
				projectUsers: {
					summary: '{users} user(s) • {equations} equation(s)',
					equation: 'Graph / Equation',
					notifications: 'Notifications',
					addUserPlaceholder: 'Add user...',
					remove: 'Remove',
					removeTitle: 'Remove User',
					confirmRemove: 'Remove {name} from alerts?',
					unsaved: 'Unsaved changes',
					save: 'Save',
					saveSuccess: 'Alert settings saved.',
					saveError: 'Failed to save alert settings.',
					noEquations: 'No equations configured for this project.',
				},
			},
		},
		de: {
			alerts: {
				common: {
					dash: '—',
					na: 'k. A.',
					general: 'Allgemein',
					unassigned: 'Nicht zugewiesene Graphen',
					refresh: 'Aktualisieren',
					dismiss: 'Schließen',
				},
				overview: {
					title: 'Alarmübersicht',
					subtitle: 'Projekte, Standorte, Hubs und Module mit ihren letzten Zuständen.',
					refreshError: 'Alarmdaten konnten nicht aktualisiert werden.',
					loadError: 'Alarmdaten konnten nicht geladen werden.',
				},
				graphs: {
					title: 'Graph-Alarme',
					subtitle: 'Graphen, die aktuell im Alarm- oder Warnzustand sind.',
					table: {
						graph: 'Graph / Gleichung',
						location: 'Standort',
						status: 'Status',
						lastWarn: 'Letzte Warnung',
						lastAlert: 'Letzter Alarm',
						noData: 'Keine Alarme für Graphen erkannt.',
					},
					status: {
						alert: 'Alarm',
						warning: 'Warnung',
						ok: 'OK',
					},
				},
				matrixGraphs: {
					title: 'Aktuelle Graph-Zustände',
					filterLabel: 'Nur Alarme & Warnungen anzeigen',
					projectLabel: 'Projekt',
					allProjects: 'Alle Projekte',
				},
				widget: {
					title: 'Alarme',
					alert: 'Alarm',
					warn: 'Warnung',
					ok: 'OK',
					empty: 'Keine Alarme konfiguriert',
				},
				matrixUsers: {
					headers: {
						phone: 'Telefon',
						role: 'Rolle',
						email: 'E-Mail',
						sms: 'SMS',
						contact: 'Kontakt',
						warn: 'Warn',
						alert: 'Alarm',
					},
					footerSelectAll: 'Alle auswählen',
					empty: 'Keine Custom-Graphen passen zum aktuellen Filter.',
					unknownUser: 'Unbekannter Benutzer',
				},
				matrixGraphTable: {
					headers: {
						graph: 'Graph / Gleichung',
						state: 'Status',
						lastState: 'Letzter Status',
						projectNumber: 'Projekt #',
						project: 'Projekt',
						location: 'Standort',
						lastCase: 'Letzter Fall',
						sentAt: 'Gesendet am',
						ok: 'OK',
						preWarn: 'PreWarn',
						warn: 'Warn',
						warnPreAlert: 'WarnPreAlert',
						preAlert: 'PreAlert',
						alert: 'Alarm',
					},
					noProject: 'Kein Projekt',
					noData: 'Keine Graph-Alarmdaten verfügbar.',
				},
				byUser: {
					status: 'Status',
					analyze: 'Daten analysieren',
					send: 'Nachrichten senden',
					projectLabel: 'Projekt',
					allProjects: 'Alle Projekte',
					selectProject: 'Projekt auswählen',
					onlyAlerts: 'Nur Graphen mit Alarm oder Warnung',
					usersEquations: '{users} Benutzer • {equations} Gleichungen',
					unsaved: 'Ungespeicherte Änderungen',
					save: 'Speichern',
					modalTitle: 'Alarmstatus-Übersicht',
					modalAlt: 'Statusanalyse',
					confirmSend: 'Warn-E-Mails an Empfänger senden?',
					toastAnalyzeSuccess: 'Alarmdaten erfolgreich neu berechnet.',
					toastAnalyzeError: 'Alarmdaten konnten nicht analysiert werden.',
					toastSendSuccess: 'Nachrichten wurden in die Warteschlange gestellt.',
					toastSendError: 'Nachrichten konnten nicht gesendet werden.',
					toastSaveSuccess: 'Alarm-Einstellungen gespeichert.',
					toastSaveError: 'Alarm-Einstellungen konnten nicht gespeichert werden.',
				},
				projectUsers: {
					summary: '{users} Benutzer • {equations} Gleichung(en)',
					equation: 'Graph / Gleichung',
					notifications: 'Benachrichtigungen',
					addUserPlaceholder: 'Benutzer hinzufügen...',
					remove: 'Entfernen',
					removeTitle: 'Benutzer entfernen',
					confirmRemove: '{name} von Alarmen entfernen?',
					unsaved: 'Ungespeicherte Änderungen',
					save: 'Speichern',
					saveSuccess: 'Alarm-Einstellungen gespeichert.',
					saveError: 'Alarm-Einstellungen konnten nicht gespeichert werden.',
					noEquations: 'Keine Gleichungen für dieses Projekt konfiguriert.',
				},
			},
		},
	},
}
